const AlarmsIndexToName = {
    "1": "Grid Level 1 Overvoltage",
    "2": "Grid Level 2 Overvoltage",
    "3": "Grid Level 1 Undervoltage",
    "4": "Grid Level 2 Undervoltage",
    "5": "Grid Level 1 Overfrequency",
    "6": "Grid Level 2 Overfrequency",
    "7": "Grid Level 1 Underfrequency",
    "8": "Grid Level 2 Underfrequency",
    "9": "Inverter Hardware Overcurrent",
    "10": "Inverter Software Overcurrent",
    "11": "Bus Hardware Overvoltage",
    "12": "Bus Software Overvoltage",
    "13": "Leakage Current Warning",
    "14": "Leakage Current Detection Circuit Fault",
    "15": "Relay Fault",
    "16": "Insulation Resistance Too Low",
    "17": "DC Component Warning",
    "18": "Master-Slave Communication Fault",
    "19": "PV Soft Start Failure",
    "20": "Sampling Bias Error Large",
    "21": "Inverter Overtemperature Warning",
    "22": "LLC Soft Start Failure",
    "23": "MidBUS Overvoltage",
    "24": "MidBUS Overcurrent",
    "25": "PV1 Overvoltage",
    "26": "PV1 Undervoltage",
    "27": "PV2 Overvoltage",
    "28": "PV2 Undervoltage",
    "29": "PV1 Overcurrent",
    "30": "PV2 Overcurrent",
    "31": "RTC Clock Fault",
    "32": "EEPROM Read/Write Failure",
    "33": "Inverter Soft Start Failure",
    "34": "Fan Fault",
    "35": "Command Shutdown",
    "36": "Utility Power Loss",
    "37": "Load Overcurrent",
    "38": "Battery Overcurrent",
    "39": "Battery Overvoltage",
    "40": "Battery Not Connected",
    "41": "Emergency Stop Alarm",
    "42": "PV1 Hardware Overcurrent",
    "43": "PV2 Hardware Overcurrent",
    "44": "Battery Hardware Overcurrent",
    "45": "Midbus Hardware Overcurrent",
    "46": "Midbus Hardware Overvoltage",
    "47": "CAN Communication Fault",
    "48": "UPS Overload",
    "49": "External Battery Abnormal",
    "50": "Load Hardware Error",
    "51": "Battery Low Voltage",
    "52": "Ground Fault",
    "53": "Drm0 Fault",
    "54": "Charge/Discharge Time Conflict",
    "55": "Poor Grid Quality",
    "56": "Meter Loss",
    "57": "BMS Charging Prohibited",
    "58": "BMS Discharging Prohibited",
    "59": "Neutral Line Reset Fault",
    "61": "Parallel Operation Fault",
    "62": "Force SOC Calibration Recovery",
    "63": "Meter Direction Error",
    "100": "SUB Rely Command Alarm(Warning)",
    "101": "Battery high Voltage(Warning)",
    "102": "Battery Low Voltage(Warning)",
    "103": "Battery High Temp(Warning)",
    "104": "Battery Low Temp(Warning)",
    "105": "",
    "106": "",
    "107": "Battery High Current Discharge(Warning)",
    "108": "Battery High Current Charge(Warning)",
    "109": "",
    "110": "",
    "111": "BMS Internal(Warning)",
    "112": "Cell Imbalance(Warning)",
    "113": "",
    "114": "",  
    "115": "",
    "116": "",
    "117": "Battery high Voltage(Alarm)",
    "118": "Battery Low Voltage(Alarm)",
    "119": "Battery High Temp(Alarm)",
    "120": "Battery Low Temp(Alarm)",
    "121": "",
    "122": "",
    "123": "Battery High Current Discharge(Alarm)",
    "124": "Battery High Current Charge(Alarm)",
    "125": "",
    "126": "",
    "127": "BMS Internal(Alarm)",
    "128": "Cell Imbalance(Alarm)",
    "129": "SUB Pack1 Error(Alarm)",
    "130": "SUB Pack2 Error(Alarm)",
    "131": "",
}

export default {AlarmsIndexToName};